class Tooltip {

    /**
     * @param {jQuery} $target
     * @param {Object} config
     */
    constructor($target, config = {}) {
        this.$target = $target;
        this.config = config;
    }

    /**
     * @returns {Tooltip}
     */
    init() {
        this.$target.tooltipster(this.getOptions());

        return this;
    }

    getOptions() {
        const title = this.$target.attr('title');
        const content = $(title).length
            ? $(title)
            : $(`<span>${title}</span>`);

        let options = {
            content,
            maxWidth: '80%',
        };

        this.addOption('tooltip-theme', 'theme', options);
        this.addOption('interactive', 'interactive', options);
        this.addOption('position', 'position', options);

        return options;
    }

    addOption(dataKey, option, options) {
        let optionsValue = this.$target.data(dataKey);

        if (optionsValue) {
            options[option] = optionsValue;
        }
    }
}

export default Tooltip;
